import React from 'react'
import { FeatureUnavailable } from 'admin-web-ui'

export const EncryptedEmailDashboard: React.FC = () => (
  <FeatureUnavailable
    pageHeading="Email"
    ctaHeading="Support private custom emails for your customers"
    ctaDescription={`
      The Sudo Platform offers a more secure, full featured email service that puts your 
      users back in control of their private information.
      `}
    ctaSubDescription={`
        Send and receive emails, custom email addresses, email blocking, custom folders, and more.
      `}
    ctaLink="https://sudoplatform.com/open-communications/email/"
    imagePath="/images/img-email"
  />
)
